import React from 'react'
import Checkbox from 'material-ui/Checkbox'

const FormCheckbox = ({
  value = false,
  onChange,
  ...props,
}) => {
  return (
    <Checkbox
      {...props}
      checked={value}
      onCheck={(e, checked) => onChange(checked)}
    />
  )
}

FormCheckbox.propTypes = {}
FormCheckbox.defaultProps = {}

export default FormCheckbox



// WEBPACK FOOTER //
// ./src/components/forms/bases/FormCheckbox.js